export enum FaceRecognizingEvent {
  homeViewedStarted = '[Web Assistant] Home viewed started',
  termsAndConditionsAccepted = '[Web Assistant] T&C Accepted',
  completedGuestForm = '[Web Assistant] Personal Information Completed',
  faceRegistrationStarted = '[Web Assistant] Face Registration Started',
  incompleteRegistration = '[Web Assistant] Incomplete Registration',
  succesfulFaceRegistration = '[Web Assistant] Face Registration Completed',
  unsuccesfulFaceRegistration = '[Web Assistant] Unsuccesful Face Registration'
}

export enum Platform {
  assistant = 'Link de invitación',
  web = 'Web',
  app = "App",
  dashboardAdmin = "Dashboard del admin",
  dashboardVigilant = "Dashboard del guardia"
}

export enum AccessType{
  fastpass = 'fastpass',
  frequentAccess = 'frequentAccess',
}

export enum UserRol{
  tenant = 'Residente', 
  proprietor = 'Propietario',
  admin = 'Administrador',
  biometric = 'Usuario biométrico'
}

export enum ScanType{
  resident = 'Residente',
  visit = 'Visita',
  profile = 'Perfil'
}

export enum VisitType{
  collaborator = 'Colaborador', 
  visit = 'Visitante', 
  delivery = "Delivery", 
  provider = "Proveedor", 
  guest = "Huesped", 
  package = "Paquete",
  resident = "Residente",
  profile = "Perfil"
}

export class RecognizingGenericEvent{
  'Tipo de Escaneo': ScanType;
  'Rol'?: UserRol;
  'Tipo de Visita': VisitType;
  'Plataforma':Platform;
  'Tipo de Acceso'?: AccessType;
  'Ph id'?: string;
  'Ph name'?: string;
  'FastPass ID'?: string;
}

export class HomeViewedStarted extends RecognizingGenericEvent{}
export class TermsAndConditionsAccepted extends RecognizingGenericEvent{}
export class CompletedGuestForm extends RecognizingGenericEvent{}
export class FaceRegistrationStarted extends RecognizingGenericEvent{}
export class SuccesfulFaceRegistration extends RecognizingGenericEvent{}
export class IncompleteRegistration extends RecognizingGenericEvent{
  'Continue': boolean;
}
export class UnsuccesfulFaceRegistration {
  'imageCaptured':boolean;
  'blinkedTimes':number;
  'partialPassed':boolean;
  'texturesScores': string;
  'texturesPassed': boolean;
  'brightnessScores':string;
  'brightnessPassed':boolean;
  'generalPassed':boolean;
  'pupilVariationPassed':boolean;
  'mouthVariationPassed':boolean;
  'pupilVariation':number;
  'mouthVariation':number;
}


export type RecognizingFaceEventData =
  | TermsAndConditionsAccepted
  | CompletedGuestForm
  | FaceRegistrationStarted
  | SuccesfulFaceRegistration
  | IncompleteRegistration
  | UnsuccesfulFaceRegistration
  | HomeViewedStarted;

export type RecognizingFaceEventRecord = Record<string, RecognizingFaceEventData>;

export const WEB_ASSISTANT_ID = "WEB_ASSISTANT_AMPLITUDE";